module.exports = __webpack_public_path__ + "img/figure-6.640f5d18.png";